module.exports = __webpack_public_path__ + "static/smi3-ea7bb85921f0a434cecd4b6e32411410.png";